module.exports = __webpack_public_path__ + "static/media/category-view-icon-box.940b6247.svg";